import { render } from "./marcarprioridaddelimpieza.vue?vue&type=template&id=c59935d2&scoped=true"
import script from "./marcarprioridaddelimpieza.vue?vue&type=script&lang=js"
export * from "./marcarprioridaddelimpieza.vue?vue&type=script&lang=js"

import "./marcarprioridaddelimpieza.vue?vue&type=style&index=0&id=c59935d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c59935d2"]])

export default __exports__